import 'flowbite';
import './modules/widgets/countdown.js';
import './modules/forms/formset.js';
import './modules/widgets/toast.js';
import './modules/integrations/htmx-skeleton.js';
import './modules/integrations/auth-particles.js';
import tabsManager from "./modules/widgets/tabs.js";
import tableManager from "./modules/widgets/table.js";
import chartManager from "./modules/widgets/dashboard-chart.js";
import challengeFilterManager from "./modules/widgets/challenge-filter.js";
import Alpine from './modules/core/alpine-helpers.js';
import {initializeAlpine, processTeleportedTemplates} from './modules/core/alpine-helpers.js';
import {initUI, setupHTMXLoadHandler} from './modules/core/ui-initializer.js';
import {setupEventHandlers} from './modules/core/event-handlers.js';
import WebSocketManager from './modules/core/websocket.js';

// Global exports
window.tabsManager = tabsManager;
window.tableManager = tableManager;
window.chartManager = chartManager;
window.challengeFilterManager = challengeFilterManager;

window.Alpine = Alpine;

// Initialize Alpine
initializeAlpine();

// Setup HTMX load handler
setupHTMXLoadHandler(() => processTeleportedTemplates(initUI));

// Setup event handlers
setupEventHandlers();

// Initialize WebSocket Manager
const wsManager = new WebSocketManager();
window.wsManager = wsManager;

document.addEventListener('DOMContentLoaded', () => {
    wsManager.init();
});
